<template>
  <span :class="['label', 'label-' + state]">
    <slot />
  </span>
</template>

<script>
export default {
  props: {
    state: {
      type: String,
    },
  },
  computed: {},
};
</script>

<style scoped>
.label {
  font-size: 10px;
  padding: 2px 3px;
  color: #fff;
  border-radius: 4px;
}

.label-newly {
  background-color: #c9b995;
}
.label-preparing {
  background-color: #c9b995;
}
.label-prepared {
  background-color: #c9b995;
}
.label-processing {
  background-color: #c9b995;
}
.label-received {
  background-color: #c9b995;
}
.label-qualitied {
  background-color: #c9b995;
}

.label-finished {
  background-color: #c9b995;
}
.label-reworking {
  background-color: #e6a23c;
}
.label-returned {
  background-color: #7a4848;
}
.label-canceled {
  background-color: #cccccc;
}
.label-outed {
  background-color: #c9b995;
}
.label-applying {
  background-color: #c9b995;
}
.label-ined {
  background-color: #c9b995;
}
.label-rejected {
  background-color: #c9b995;
}
.label-agreed {
  background-color: #c9b995;
}
.label-picking {
  background-color: #c9b995;
}

/* scheduleStates: {
      undo: '未做',
      done: '已完成', // “转化”   //做了买了
      canceled: '取消',
      giveUp: '放弃' // 做了没买
    }, */
.label-undo {
  background-color: #92d1e0;
}
.label-done {
  background-color: #81ace4;
}

.label-giveUp {
  background-color: #eb5e5e;
}
</style>